import { ArrowDownIcon, ArrowUpIcon } from '@ngg/icons';

export default function Icon({ open }: { open: boolean }) {
    if (open) return <ArrowUpIcon className="text-base" />;
    return <ArrowDownIcon className="text-base" />;
}
